module.exports = __webpack_public_path__ + "static/media/favicon.7c950981.ico";